import * as React from 'react';

/** Material UI Packages. */
import { Typography, Link } from '@mui/material';

/** Internal Components. */
import {
    arrival_notice_status,
    ocean_freight_status,
    ocean_freight_method,
    air_freight_status,
    aes_status,
    shipping_instruction_status,
    invoice_crdr_status,
    booking_status,
    dg_hazmat_status,
} from 'shared/config/constantsData';
import { CustomSelectCell_string, MultiLinkCell, MultiLinkEditCell, DateTypingEditCell } from 'shared/ui/RenderCell';
import { customized_style } from 'shared/config/Styles';
import 'shared/config/Styles.css';
import { getClassName, getHeaderClass } from 'shared/lib/todoColorHandler';
import { parseDateToLocal } from 'shared/lib/dateFormatter';
import { parsePastedDate } from 'shared/lib/datagridHelpers';
import { isAssistantManagerOrAbove } from 'shared/lib/roles';

export const bookingConfirmationCol = (presetData, todo) => {
    let isHighlighted_booking_confirmation = todo?.length ? getClassName(todo, 'booking_confirmation', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'booking_confirmation',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: true,
            align: 'center',
            headerAlign: 'center',
            valueOptions: booking_status.map((item) => item.content),
            headerClassName: getHeaderClass(true, isHighlighted_booking_confirmation),
            renderCell: (params) => {
                return <span style={{ color: true ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={booking_status} />,
        },
        {
            field: 'booking_confirmation_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 0.8,
            editable: true,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(true, isHighlighted_booking_confirmation),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';
                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: true ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};

export const dgHazmatCol = (presetData, todo) => {
    const dgHazmat = presetData?.dg_hazmat;
    let isHighlighted_dg_hazmat = todo?.length ? getClassName(todo, 'dg_hazmat', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'dg_hazmat',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: dgHazmat,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(dgHazmat, isHighlighted_dg_hazmat),
            renderCell: (params) => {
                return <span style={{ color: dgHazmat ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={dg_hazmat_status} />,
        },
        {
            field: 'dg_hazmat_link',
            headerName: 'Link',
            flex: 1,
            editable: dgHazmat,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(dgHazmat, isHighlighted_dg_hazmat),
            renderCell: (params) => {
                const linkStyle = !dgHazmat ? { color: '#C7C7C7' } : {};
                const handleClick = (event) => {
                    if (!dgHazmat) {
                        event.preventDefault();
                    }
                };
                return (
                    <Link
                        href={params.value ? `${params.value}` : '#'}
                        target="_blank"
                        rel="noopener"
                        style={linkStyle}
                        onClick={handleClick}
                    >
                        {params.value ? 'View File' : ''}
                    </Link>
                );
            },
        },
        {
            field: 'dg_hazmat_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 0.8,
            editable: dgHazmat,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(dgHazmat, isHighlighted_dg_hazmat),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';
                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: dgHazmat ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};

/** No use anymore.  */
export const arrivalNoticeCol = (presetData, todo) => {
    const arrivalNotice = presetData?.arrival_notice;
    let isHighlighted_arrivalnotice = todo?.length ? getClassName(todo, 'arrival_notice', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'arrival_notice',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: arrivalNotice,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(arrivalNotice, isHighlighted_arrivalnotice),
            renderCell: (params) => {
                return <span style={{ color: arrivalNotice ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={arrival_notice_status} />,
        },
        {
            field: 'arrival_notice_link',
            headerName: 'Link',
            flex: 1,
            editable: arrivalNotice,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(arrivalNotice, isHighlighted_arrivalnotice),
            renderCell: (params) => {
                const linkStyle = !arrivalNotice ? { color: '#C7C7C7' } : {};
                const handleClick = (event) => {
                    if (!arrivalNotice) {
                        event.preventDefault();
                    }
                };
                return (
                    <Link
                        href={params.value ? `${params.value}` : '#'}
                        target="_blank"
                        rel="noopener"
                        style={linkStyle}
                        onClick={handleClick}
                    >
                        {params.value ? 'View File' : ''}
                    </Link>
                );
            },
        },
    ];
};

export const oceanFreightCol = (presetData, todo) => {
    const oceanFreight = presetData?.ocean_freight;
    let isHighlighted_oceanfreight = todo?.length ? getClassName(todo, 'ocean_freight', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'ocean_freight',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1.2,
            editable: oceanFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(oceanFreight, isHighlighted_oceanfreight),
            renderCell: (params) => {
                return <span style={{ color: oceanFreight ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={ocean_freight_status} />,
        },
        {
            field: 'paid_with',
            headerName: 'Pay Method',
            type: 'singleSelect',
            flex: 1,
            editable: oceanFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(oceanFreight, isHighlighted_oceanfreight),
            renderCell: (params) => {
                return <span style={{ color: oceanFreight ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={ocean_freight_method} />,
            renderHeader: () => {
                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            fontWeight: 500,
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            lineHeight: 1.2,
                            fontSize: '11px',
                        }}
                    >
                        Pay Method
                    </Typography>
                );
            },
        },
        {
            field: 'paid_on',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 0.8,
            editable: oceanFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(oceanFreight, isHighlighted_oceanfreight),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';
                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: oceanFreight ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
        {
            field: 'ocean_freight_link',
            headerName: 'Link',
            flex: 0.5,
            editable: oceanFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(oceanFreight, isHighlighted_oceanfreight),
            renderCell: (params) => {
                const linkStyle = !oceanFreight ? { color: '#C7C7C7' } : {};
                const handleClick = (event) => {
                    if (!oceanFreight) {
                        event.preventDefault();
                    }
                };
                return (
                    <Link
                        href={params.value ? `${params.value}` : '#'}
                        target="_blank"
                        rel="noopener"
                        style={linkStyle}
                        onClick={handleClick}
                    >
                        {params.value ? 'View File' : ''}
                    </Link>
                );
            },
        },
    ];
};

export const airFreightCol = (presetData, todo) => {
    const airFreight = presetData?.air_freight;
    let isHighlighted_airfreight = todo?.length ? getClassName(todo, 'air_freight', 'header') : '';
    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'air_freight',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: airFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(airFreight, isHighlighted_airfreight),
            renderCell: (params) => {
                return <span style={{ color: airFreight ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={air_freight_status} />,
        },
        {
            field: 'paid_with',
            headerName: 'Pay Method',
            type: 'singleSelect',
            flex: 1,
            editable: airFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(airFreight, isHighlighted_airfreight),
            renderCell: (params) => {
                return <span style={{ color: airFreight ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={ocean_freight_method} />,
            renderHeader: () => {
                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            fontWeight: 500,
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            lineHeight: 1.2,
                            fontSize: '11px',
                        }}
                    >
                        Pay Method
                    </Typography>
                );
            },
        },
        {
            field: 'paid_on',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 0.8,
            editable: airFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(airFreight, isHighlighted_airfreight),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';

                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: airFreight ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
        {
            field: 'air_freight_link',
            headerName: 'Link',
            flex: 0.5,
            editable: airFreight,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(airFreight, isHighlighted_airfreight),
            renderCell: (params) => {
                const linkStyle = !airFreight ? { color: '#C7C7C7' } : {};
                const handleClick = (event) => {
                    if (!airFreight) {
                        event.preventDefault();
                    }
                };
                return (
                    <Link
                        href={params.value ? `${params.value}` : '#'}
                        target="_blank"
                        rel="noopener"
                        style={linkStyle}
                        onClick={handleClick}
                    >
                        {params.value ? 'View File' : ''}
                    </Link>
                );
            },
        },
    ];
};

export const siCol = (presetData, todo) => {
    const shippingInstruction = presetData?.shipping_instruction;
    let isHighlighted_shipping_instruction = todo?.length ? getClassName(todo, 'shipping_instruction', 'header') : '';
    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'shipping_instruction',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: shippingInstruction,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(shippingInstruction, isHighlighted_shipping_instruction),
            renderCell: (params) => {
                return <span style={{ color: shippingInstruction ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => (
                <CustomSelectCell_string params={params} options={shipping_instruction_status} />
            ),
        },

        {
            field: 'shipping_instruction_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 1,
            editable: shippingInstruction,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(shippingInstruction, isHighlighted_shipping_instruction),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';

                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: shippingInstruction ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};

export const aesCol = (presetData, todo) => {
    const aesItn = presetData?.aes_itn;
    let isHighlighted_aes_itn = todo?.length ? getClassName(todo, 'aes_itn', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'aes_itn',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: aesItn,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(aesItn, isHighlighted_aes_itn),
            renderCell: (params) => {
                return <span style={{ color: aesItn ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => <CustomSelectCell_string params={params} options={aes_status} />,
        },
        {
            field: 'aes_itn_number',
            headerName: 'Number',
            flex: 1.2,
            editable: aesItn,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(aesItn, isHighlighted_aes_itn),
            renderCell: (params) => {
                return <span style={{ color: aesItn ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
        },
        {
            field: 'aes_itn_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 0.8,
            editable: aesItn,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(aesItn, isHighlighted_aes_itn),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';

                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: aesItn ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};

/** No use anymore.  */
export const invoiceCol = (presetData, userRole, todo) => {
    const invoice = presetData?.invoice;
    let isHighlighted_invoice = todo?.length ? getClassName(todo, 'invoice', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'invoice',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: invoice,
            align: 'center',
            headerAlign: 'center',
            valueOptions: invoice_crdr_status,
            headerClassName: getHeaderClass(invoice, isHighlighted_invoice),
            renderCell: (params) => {
                return <span style={{ color: invoice ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => {
                const allowedStatuses = ['Pending', 'Ready', 'Sent'];
                const hasOperationManagerRole =
                    isAssistantManagerOrAbove(userRole);
                return (
                    <CustomSelectCell_string
                        params={params}
                        options={invoice_crdr_status}
                        hasOperationManagerRole={hasOperationManagerRole}
                        allowedStatuses={allowedStatuses}
                    />
                );
            },
        },
        {
            field: 'invoice_link',
            headerName: 'Link',
            flex: 1,
            editable: invoice,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(invoice, isHighlighted_invoice),
            renderCell: (params) => <MultiLinkCell params={params} enabled={invoice} />,
            renderEditCell: (params) => <MultiLinkEditCell params={params} />,
        },
        {
            field: 'invoice_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 1,
            editable: invoice,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(invoice, isHighlighted_invoice),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';

                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: invoice ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};
/** No use anymore.  */
export const crdrCol = (presetData, userRole, todo) => {
    const crdr = presetData?.crdr;
    let isHighlighted_crdr = todo?.length ? getClassName(todo, 'crdr', 'header') : '';

    return [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
        },
        {
            field: 'crdr',
            headerName: 'Status',
            type: 'singleSelect',
            flex: 1,
            editable: crdr,
            align: 'center',
            headerAlign: 'center',
            valueOptions: invoice_crdr_status,
            headerClassName: getHeaderClass(crdr, isHighlighted_crdr),
            renderCell: (params) => {
                return <span style={{ color: crdr ? 'inherit' : '#C7C7C7' }}>{params.value}</span>;
            },
            renderEditCell: (params) => {
                const allowedStatuses = ['Pending', 'Ready', 'Sent'];
                const hasOperationManagerRole =
                    isAssistantManagerOrAbove(userRole);
                return (
                    <CustomSelectCell_string
                        params={params}
                        options={invoice_crdr_status}
                        hasOperationManagerRole={hasOperationManagerRole}
                        allowedStatuses={allowedStatuses}
                    />
                );
            },
        },
        {
            field: 'crdr_link',
            headerName: 'Link',
            flex: 1,
            editable: crdr,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(crdr, isHighlighted_crdr),
            renderCell: (params) => <MultiLinkCell params={params} enabled={crdr} />,
            renderEditCell: (params) => <MultiLinkEditCell params={params} />,
        },
        {
            field: 'crdr_date',
            headerName: 'Date',
            type: 'date',
            pastedValueParser: parsePastedDate,
            flex: 1,
            editable: crdr,
            align: 'center',
            headerAlign: 'center',
            headerClassName: getHeaderClass(crdr, isHighlighted_crdr),
            valueGetter: (params) => {
                return parseDateToLocal(params);
            },
            renderCell: (params) => {
                const date = parseDateToLocal(params.value);
                const formattedDate = date
                    ? date.toLocaleDateString('en-US', {
                          year: '2-digit',
                          month: '2-digit',
                          day: '2-digit',
                      })
                    : '';

                return (
                    <Typography
                        sx={{
                            ...customized_style.itemDatagrid_Typography,
                            color: crdr ? 'inherit' : '#C7C7C7',
                        }}
                    >
                        {formattedDate}
                    </Typography>
                );
            },
            renderEditCell: (params) => <DateTypingEditCell params={params} />,
        },
    ];
};
